import { render, staticRenderFns } from "./events-list.vue?vue&type=template&id=8b990ca0&scoped=true&"
import script from "./events-list.vue?vue&type=script&lang=js&"
export * from "./events-list.vue?vue&type=script&lang=js&"
import style0 from "./events-list.vue?vue&type=style&index=0&id=8b990ca0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b990ca0",
  null
  
)

export default component.exports